t = require('app/scripts/views/internal/teacup-with-helpers')('label_limit_exceeded')

module.exports = ->
  t.span { class: 'error' }, ->
    t.format 'board-label-limit-exceeded'
